import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/proceso_asincrono_calculado';

/**
 * GET Procesos Asincronos Calculados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getProcesosAsincronosCalculados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Proceso Asincrono Calculado
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getProcesoAsincronoCalculado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Proceso Asincrono Calculado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postProcesoAsincronoCalculado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Proceso Asincrono Calculado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchProcesoAsincronoCalculado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Proceso Asincrono Calculado
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteProcesoAsincronoCalculado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
